import api from "./api";

export const fetchProductsList = async () => {
  const { data } = await api.get(`/product`);
  return data;
};
